import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import {cssCFButton} from 'module/CustomField/component/button/cssCFButton';
import ClearAll from '@mui/icons-material/ClearAll';

interface Props {
	onClick: () => void
}

export function ClearCFRowsButton({onClick}: Props) {
	return <Tooltip title={'Zeilen aufräumen'}>
		<Button
			css={cssCFButton.btn}
			size={'small'}
			onClick={onClick}
		>
			<ClearAll/>
		</Button>
	</Tooltip>
}